import store from '../store'
export default ({to, form, router, next}) => {
	const vuex = store
	const user = JSON.parse(localStorage.getItem('auth')) || null
	vuex.commit('auth/setAuthUser', user)
	return next();
}
